import { Space, Typography } from 'antd'
import { useTranslation } from 'react-i18next'

import type { FulfillmentOrderRoot } from '@repo/sdk'

import { StatusBadge } from '../../components/StatusBadge'
import { formatKrw } from '@repo/shared'
import { useFoDisplayStatusConfig } from './foDisplayStatusConfig'
import { FoAnnotationBadge } from './FoAnnotationBadge'
import { OrderItemsCard } from './OrderItemsCard'
import { formatFoContext } from './orderDisplay'
import { sumFulfillmentOrderAmount } from './buyerGroupSummary'

interface BuyerGroupFoCardProps {
  order: FulfillmentOrderRoot
}

/** One fulfillment order inside a buyer group: its own channel, status and amount. */
export function BuyerGroupFoCard({ order }: BuyerGroupFoCardProps) {
  const { t } = useTranslation()
  const statusConfig = useFoDisplayStatusConfig()

  return (
    <div data-testid={`order-detail-group-fo-${order.fulfillmentOrderId}`}>
      <Space style={{ marginBottom: 8 }} wrap>
        <Typography.Text type="secondary">{formatFoContext(order, t)}</Typography.Text>
        <StatusBadge status={order.displayStatus} configMap={statusConfig} />
        <FoAnnotationBadge annotation={order.annotation} />
        <Typography.Text strong>{formatKrw(sumFulfillmentOrderAmount(order))}</Typography.Text>
      </Space>
      <OrderItemsCard order={order} />
    </div>
  )
}
